require('../../components/raq-dealer-info/raq-dealer-info.tag');



riot.tag2('raq-dealer-container', '<span class="raq-dealer-required-label acr-paragraph-8">{labels.dealer.dealerError}</span> <yield></yield>', '', 'class="raq-dealer {state} {\'raq-required-field\': dealerNotSelected}"', function(opts) {
  this.mixin('cookie');
  this.mixin('bus');
  require('es6-promise').polyfill();

  const CONSTANTS = require('../../core/platform/constants.js').default;
  const ERRORS = require('../../core/platform/errors.js').default;
  const dealersSvc = require('../../core/dealers.js');
  const params = require('../../core/params');

  const self = this;

  self.state = CONSTANTS.states.default;
  self.dealerId = self.opts.dealerId;
  self.dealer = null;
  self.showChangeDealer = false;
  self.modalRAQ = document.querySelector('.modal-raq')
                  || document.querySelector('bap-content-modal')
                  || document.querySelector('offers-modal-wrapper');

  self.cookiePreferred = self.cookie.get(CONSTANTS.preferredDealerIdCookieName);

  self.dealerNotSelected = false;

  function checkPreferred(dealerId = self.opts.dealerId) {
    if (self.cookiePreferred) {
      if (self.cookiePreferred === dealerId) {
        return true;
      }
    }
    return false;
  }

  function setPreferred(data) {
    self.cookie.set(CONSTANTS.preferredDealerIdCookieName, data.dealerId,
      {
        path: '/',
      });
    self.cookie.set(CONSTANTS.dealerNameCookieName, data.dealerName,
      {
        path: '/',
      });
  }

  function unsetPreferred() {
    self.cookie.set(CONSTANTS.preferredDealerIdCookieName, '', { maxAge: -1, path: '/' });
    self.cookie.set(CONSTANTS.dealerNameCookieName, '', { maxAge: -1, path: '/' });
  }

  function checkAppendDealerLocator() {
    // Gets dealer locator tool markup from view and moving it to raq-dealer-container body
    // This to avoid dealer-locator-container parameters to be handle by raq-wrapper
    const dealerLocatorContainer = document.querySelectorAll('dealer-locator-container[data-is-embedded-in-raq="True"]');

    if (dealerLocatorContainer.length > 0) {
      self.root.appendChild(dealerLocatorContainer[0]);
      self.showChangeDealer = true;
    } else {
      console.warn(ERRORS.noDealerLocator);
    }
  }

  // Fetch dealer if self.opts.dealerId is a string, populate self.dealer, trigger fetched event.
  function updateDealerInfo(dealerId, udpateVehicle = false, closeDealer = true) {
    if ((dealerId !== '') && (typeof dealerId === 'string')) {
      self.dealer = dealersSvc.getDealer(dealerId)
        .then((dealerObj) => {
          self.dealer = dealerObj;
          if (closeDealer) {
            self.state = CONSTANTS.states.default;
          }
          self.isPreferred = checkPreferred(self.dealer.dealerId);
          self.update();
          params.setLocalDealer(dealerObj.dealerId, dealerObj.name,
            self.dealer.zip, dealerObj.address, dealerObj.phone);
          self.bus.trigger(self.bus.EVENTS.DEALERS.DEALER_FETCHED);
          self.bus.trigger(self.bus.EVENTS.STEPS.DEALER_UPDATED, { origin: 'dealer' });
          if (udpateVehicle) {
            self.bus.trigger(self.bus.EVENTS.VEHICLE.UPDATE);
          }
        })
        .catch((error) => {
          self.dealer = null;
          self.update();
          self.bus.trigger(self.bus.EVENTS.DEALERS.DEALER_FETCHED);
          if (error.response && error.response.status !== 422) {
            window.console.warn(ERRORS.endpointFailed, error.response);
            self.bus.trigger(self.bus.EVENTS.CONTAINER.ERROR);
          }
        });
    } else if (self.dealerId === '' && self.opts.dealerObj && self.opts.dealerObj.DealerNumber > 0) {
      // ASA scenario (backend provides dealerObj).
      self.dealer = dealersSvc.mapDealer(self.opts.dealerObj);
      self.dealerId = self.dealer.dealerId;
      self.state = CONSTANTS.states.default;
      self.isPreferred = checkPreferred(self.dealer.dealerId);
      params.setLocalDealer(self.dealer.dealerId, self.dealer.name,
        self.dealer.zip, self.dealer.address, self.dealer.phone);
      self.bus.trigger(self.bus.EVENTS.DEALERS.DEALER_FETCHED);
      self.bus.trigger(self.bus.EVENTS.STEPS.DEALER_UPDATED, { origin: 'dealer' });
      checkAppendDealerLocator();
      self.update();
    }
  }

  function updateDealer(data) {
    let objTemp = null;
    if (data && data.type === 'select' && data.parameters && data.parameters[0]) {
      objTemp = JSON.parse(JSON.stringify(data.parameters[0]).toLowerCase());

      const userData = params.userData();
      const vehicleUpdateFlag = !userData || !userData.carModelYear || !userData.carModelName;

      if (objTemp.dealerid) {
        self.dealerId = objTemp.dealerid;
        updateDealerInfo(objTemp.dealerid, vehicleUpdateFlag);
        self.bus.trigger(self.bus.EVENTS.DEALERS.CHECK_PREFERRED);
        // Change dealer container state to show select a dealer
        if (window.raq.dlEvents) {
          window.raq.dlEvents.trigger(window.raq.dlEvents.EVENTS.LOCATOR.FOCUS);
        }
        self.dealerNotSelected = false;
      }
    } else {
      console.warn('Select Dealer CTA Requires: dealerid'); // eslint-disable-line no-console
    }
  }

  function initDealerLocator() {
    const zipcode = window.Acr.zipgateComponent ? window.Acr.zipgateComponent.getZipcode() : '';
    // Init dl from window.dl object
    if (!window.raq) {
      window.raq = {}; // This is just for local dev
    }
    window.raq.dlEvents = window.dl.initRaq();
  }

  function updateDealerBind() {
    initDealerLocator();
    params.setLocalDealer('', '', '', '', '');
    self.bus.trigger(self.bus.EVENTS.DEALERS.CHANGED);

    function onCtaClick(data) {
      updateDealer(data);
    }

    // Change dealer container state to show select a dealer
    if (window.raq.dlEvents) {
      window.raq.dlEvents.on(window.raq.dlEvents.EVENTS.DEALERS.CTA_CLICK, onCtaClick);
      self.state = CONSTANTS.states.selectDealer;
      self.update();
    }
  }

  function loadDealerLocator() {
    updateDealerBind();
  }

  // Function to mark the dealer section when a dealer is not selected
  function markRequiredFields(userData) {
    if (!userData.dealerId) {
      self.dealerNotSelected = true;
      self.update();
    }
  }

  self.on('mount', () => {
    updateDealerInfo(self.dealerId);
    checkAppendDealerLocator();
    loadDealerLocator();
  });

  self.bus.on(self.bus.EVENTS.DEALERS.SET_PREFERRED, setPreferred);
  self.bus.on(self.bus.EVENTS.DEALERS.UNSET_PREFERRED, unsetPreferred);
  self.bus.on(self.bus.EVENTS.DEALERS.CHANGE, updateDealerBind);
  self.bus.on(self.bus.EVENTS.DEALERS.UPDATE_DEALER_CARD, updateDealerInfo, '', false, false);
  self.bus.on(self.bus.EVENTS.FORM.REQUIRED_FIELD, markRequiredFields);
});
